module.exports = __webpack_public_path__ + "static/media/white-copy-icon.4c92d577.svg";